import React from 'react';
import Chat from '../features/chat/Chat';

const ChatPage: React.FC = () => {
    return (
        <div className="flex h-full min-h-0 w-full flex-col overflow-hidden">
            <Chat />
        </div>
    );
};

export default ChatPage;
